import { useFormat } from './useFormat';

export const useNumberFormat = ({
  maximumFractionDigits = 2,
  minimumFractionDigits = 0,
  empty = '-',
  signDisplay = 'auto',
  notation = 'standard',
  compactDisplay = 'long',
} = {}) => {
  return useFormat({
    type: 'decimal',
    maximumFractionDigits,
    minimumFractionDigits,
    empty,
    signDisplay,
    notation,
    compactDisplay,
  });
};
